/* eslint-disable no-throw-literal */
//      

                                                    

export default class BaseTracker                     {
	useEcommerce         ;
	trackingId        ;
	eventPrefix        ;

	constructor(trackingId        , withEcommerce         , eventPrefix = "SELEKT_") {
		this.useEcommerce = withEcommerce;
		this.trackingId = trackingId;
		this.eventPrefix = eventPrefix;
	}

	setEcommerce = value => {
		this.useEcommerce = value;
	};

	handleGenericEvent(cat        , action        , label     )       {
		throw ("not implemented");
	};

	handleOrderEvent(id        , revenue        )       {
		throw ("not implemented");
	};

	handleItemEvent(id        , name        , articleNumber        , price        )       {
		throw ("not implemented");
	};

	logEvent(cat        , action        , label     ) {
		this.handleGenericEvent(this.eventPrefix + cat, action, label);
	};

	logOrder(id        , revenue        ) {
		if (this.useEcommerce) {
			this.handleOrderEvent(id, revenue);
		}
	};

	logItem(id        , name        , articleNumber        , price        ) {
		if (this.useEcommerce) {
			this.handleItemEvent(id, name, articleNumber, price);
		}
	};
}
